<template>
  <div id="dog-preview">
    <iframe id="3DViewIframe" v-bind:src="initialSrc" title="Hound Preview" style="width: 100%; height: 100%"></iframe>
  </div>
</template>

<script>
import { config } from '../config';
export default {
  props: ['item'],
  setup (props) {
    // Without a configured render origin the relative "?preview=..." URL would
    // resolve against the platform itself, loading the app recursively inside
    // the iframe. Fall back to a blank page instead.
    const buildSrc = (args, includeNoGui) =>
      config.threeSceneUrl
        ? `${config.threeSceneUrl}?preview=true&antialias=true&${includeNoGui ? `noGui=${args.noGui}&` : 'noGui=true&'}noInitialLogs=true&autoRotate=${args.autoRotate}&htmlBackgroundColor=${args.htmlBackgroundColor}&lights=${args.lights}&noBackground=${args.noBackground}&arenaMode=${args.arenaMode}&genetic_sequence=${args.geneticSequence}&arenaIndex=${props.item.arenaIndex}&extensionTraits=${props.item.extensionTraits}`
        : 'about:blank';

    const initialSrc = buildSrc(props.item, false);

    function refresh(renderArguments) {
      document.getElementById('3DViewIframe').src = buildSrc(renderArguments, true);
    }

    return {
      refresh,
      initialSrc
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/mixins.scss';

iframe {
  border: none;
}

#dog-preview {
  width: 100%;
  position: relative;
  max-width: 100%;
  aspect-ratio: 3;
  @include s-down {
    aspect-ratio: 2;
  }
  @include xs-down {
    aspect-ratio: 1;
  }
}

.hound-back {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: absolute;
  transition: background-image .5s;
  top: 0;
  left: 0;
}

%colorize {
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
}

%colorize::before {
  content: '';
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

</style>
